<input #fileInput hidden="true" type="file" name="file" onclick="this.value = null" (change)="fileInputChanged($event)" [accept]="acceptedFileTypesString" />
@if (chosenFile === null) {
  <button mat-flat-button color="primary" (click)="fileInput.click()" translate="COMMON.CHOOSE_A_FILE" type="button"></button>
} @else {
  <div class="file-name-container">
    @if (!isUploading && !isScanning && !isCheckingPages) {
      <button mat-icon-button color="warn" type="button" (click)="removeFile()" [matTooltip]="'COMMON.REMOVE' | translate">
        <mat-icon>close</mat-icon>
      </button>
    }
    <span class="mask-file-names">{{ chosenFile.name }}</span> ({{ chosenFile.size | filesize }})
  </div>
  @if (limitErrorMessage) {
    <div class="file-error">{{ limitErrorMessage | translate: limitErrorParams }}</div>
  }
  @if (isCheckingPages) {
    <div class="upload-progress">
      <app-progress-loader indeterminate></app-progress-loader>
      <span class="upload-progress-text" translate="UPLOADS.CHECKING_PAGES"></span>
    </div>
  } @else if (isScanning) {
    <div class="upload-progress">
      <app-progress-loader indeterminate></app-progress-loader>
      <span class="upload-progress-text" translate="UPLOADS.SCANNING"></span>
    </div>
  } @else if (isUploading) {
    <div class="upload-progress">
      <app-progress-loader [value]="uploadProgress" loading></app-progress-loader>
      <span class="upload-progress-text">
        {{ uploadProgress }}%
        @if (remainingTimeSeconds !== null) {
          - {{ 'COMMON.TIME_REMAINING' | translate: { time: (remainingTimeSeconds | duration: true) } }}
        }
      </span>
    </div>
  }
}
